import React from "react";
import { List } from "@mui/material";
import MoreOptionsButton from "modules/common/components/buttons/moreOptionsButton";
import MoreOptionsItem from "modules/common/components/moreOptionsItem";
import { FilterOptions } from "modules/insights";

interface DateRangeSelectFilterProps {
    options: { value: FilterOptions; label: string }[];
    selectedValue: FilterOptions;
    onSelect: (value: FilterOptions) => void;
}

const DateRangeSelectFilter = ({
    options,
    selectedValue,
    onSelect,
}: DateRangeSelectFilterProps) => {
    return (
        <MoreOptionsButton
            text={options.find(opt => opt.value === selectedValue)?.label ?? ""}
            className="moreOptionsButton"
        >
            <List disablePadding>
                {options.map(opt => (
                    <MoreOptionsItem
                        key={`${opt.value}-${opt.label}`}
                        text={opt.label}
                        onClick={() => onSelect(opt.value)}
                    />
                ))}
            </List>
        </MoreOptionsButton>
    );
};

export default DateRangeSelectFilter;